"use client";

import { ArrowRight } from "lucide-react";
import { ROUTES } from "@/lib/routes";

const headingFont = { fontFamily: "var(--font-display), 'Hanken Grotesk', sans-serif" };
const bodyFont = { fontFamily: "'Figtree', var(--font-body), sans-serif" };

export default function PostFaqCtaSection() {
  return (
    <section className="flex min-h-[360px] w-full items-center justify-center bg-white px-6 py-20 md:min-h-[471px] md:px-20">
      <div className="flex w-full max-w-[830px] flex-col items-center gap-6 text-center">
        <h2
          className="max-w-[830px] text-[34px] font-bold leading-[44px] text-[#1B1C30] md:text-[52px] md:leading-[68px]"
          style={headingFont}
        >
          Start Your Free <br />Trial Today
        </h2>
        <p className="max-w-[630px] text-base leading-6 text-[#262626] md:text-lg" style={bodyFont}>
          No credit card required. Cancel anytime.
        </p>
        <div className="flex h-[68px] w-full max-w-[502px] flex-row items-center gap-6">
          <a
            href={ROUTES.pricingAnchor}
            className="inline-flex h-[68px] min-w-0 basis-[276px] items-center justify-center gap-3 whitespace-nowrap rounded-lg bg-[#1464FF] px-8 text-base font-bold leading-[30px] text-[#FAFAFA] transition-colors hover:bg-[#0D4FD6]"
            style={bodyFont}
          >
            Start Free Trial
            <ArrowRight aria-hidden="true" className="h-6 w-6" strokeWidth={1.8} />
          </a>
          <a
            href={ROUTES.howItWorksDemo}
            className="inline-flex h-[68px] min-w-0 basis-[202px] items-center justify-center gap-3 whitespace-nowrap rounded-lg border border-[#1464FF] px-8 text-base font-bold leading-[30px] text-[#1464FF] transition-colors hover:bg-[rgba(20,100,255,0.08)]"
            style={bodyFont}
          >
            Watch Demo
          </a>
        </div>
      </div>
    </section>
  );
}
